export default {
    CUSTOM_FIELD_TYPES: {
        MULTISELECT: 'MultiSelect',
        CURRENCY: 'Currency',
        DATE: 'Date',
        DATETIME: 'DateTime',
        DAY_OF_WEEK: 'DayOfWeek',
        DECIMAL_NUMBER: 'NumberDecimal',
        SELECT: 'Select',
        SELECT1: 'select',
        OPTION: 'option',
        SSN: 'SSN',
        DRILLDOWN: 'Drilldown',
        EMAIL: 'Email',
        MONTH: 'Month',
        NAME: 'Name',
        PERCENT: 'Percent',
        PHONE_NUMBER: 'Phone',
        RADIO: 'Radio',
        RADIOS: 'radio',
        STATE: 'State',
        TEXT: 'text',
        TEXTS: 'Text',
        TEXT_AREA: 'TextArea',
        WEBSITE: 'Website',
        WHOLE_NUMBER: 'Number',
        USER: 'User',
        USER_MULTISELECT: 'UserMultiSelect',
        YEAR: 'Year',
        YES_NO: 'YesNo',
        CHECKBOX: 'checkbox',
        HEADER: 'header',
        IMAGE: 'image',
        LOGO: 'logo',
        PARAGRAPH: 'paragraph',
    },

    CUSTOM_FIELD_NAMES: {
        MULTISELECT: 'ListBox',
        CURRENCY: 'Currency',
        DATE: 'Date',
        DATETIME: 'DateTime',
        DAY_OF_WEEK: 'DayOfWeek',
        DECIMAL_NUMBER: 'DecimalNumber',
        DROPDOWN: 'Dropdown',
        SSN: 'SocialSecurityNumber',
        DRILLDOWN: 'Drilldown',
        EMAIL: 'Email',
        MONTH: 'Month',
        NAME: 'Name',
        PERCENT: 'Percent',
        PHONE_NUMBER: 'PhoneNumber',
        RADIO: 'Radio',
        STATE: 'State',
        TEXT: 'Text',
        TEXT_AREA: 'TextArea',
        WEBSITE: 'Website',
        WHOLE_NUMBER: 'WholeNumber',
        USER: 'User',
        USER_MULTISELECT: 'UserListBox',
        YEAR: 'Year',
        YES_NO: 'YesNo',
    },

    CUSTOM: {
        Currency: { type: 'decimal' },
        Date: { type: 'date' },
        DateTime: { type: 'datetime' },
        DayOfWeek: { type: 'select', id: 'weekDays' },
        NumberDecimal: { type: 'decimal' },
        Email: { type: 'email' },
        Month: { type: 'select', id: 'months' },
        MultiSelect: { type: 'checkboxes', hasOptions: true },
        ListBox: { type: 'checkboxes', hasOptions: true },
        Select: { type: 'dropdown', hasOptions: true, hasSettings: true },
        Dropdown: { type: 'dropdown', hasOptions: true, hasSettings: true },
        Percent: { type: 'decimal' },
        Phone: { type: 'phone' },
        Radio: { type: 'radio', hasOptions: true },
        State: { type: 'region', id: 'customRegion' },
        Text: { type: 'text' },
        TextArea: { type: 'textarea' },
        User: { type: 'select', id: 'owners' },
        Website: { type: 'url' },
        Number: { type: 'number' },
        Year: { type: 'year' },
        YesNo: { type: 'select', id: 'yesNo' },
    },
};
